/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Odhadované doručení`
};

const da_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Forventet levering den`
};

const de_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Voraussichtliche Lieferung am`
};

const en_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Estimated delivery on`
};

const es_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Entrega estimada el`
};

const fr_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Livraison estimée le`
};

const hu_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Becsült szállítási idő`
};

const it_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Consegna stimata il`
};

const nl_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Geschatte levering op`
};

const pl_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Szacowana dostawa`
};

const pt_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Entrega estimada em`
};

const sv_checkout_estimated_delivery = /** @type {(inputs: {}) => string} */ () => {
	return `Beräknad leverans`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_estimated_delivery = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_estimated_delivery(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_estimated_delivery", locale)
	if (locale === "cs") return cs_checkout_estimated_delivery(inputs)
	if (locale === "da") return da_checkout_estimated_delivery(inputs)
	if (locale === "de") return de_checkout_estimated_delivery(inputs)
	if (locale === "en") return en_checkout_estimated_delivery(inputs)
	if (locale === "es") return es_checkout_estimated_delivery(inputs)
	if (locale === "fr") return fr_checkout_estimated_delivery(inputs)
	if (locale === "hu") return hu_checkout_estimated_delivery(inputs)
	if (locale === "it") return it_checkout_estimated_delivery(inputs)
	if (locale === "nl") return nl_checkout_estimated_delivery(inputs)
	if (locale === "pl") return pl_checkout_estimated_delivery(inputs)
	if (locale === "pt") return pt_checkout_estimated_delivery(inputs)
	return sv_checkout_estimated_delivery(inputs)
};
export { checkout_estimated_delivery as "checkout.estimated_delivery" }